import React from 'react';
import {ColumnType} from "../../api/enum/ColumnType";
import {SxProps, TextField, TextFieldProps} from "@mui/material";
import PredefinedOptionSelect from "../columns/PredefinedOptionSelect";
import {AnyColumnJson} from "../../api/json/ColumnJson";

export interface CellInputProps {
    column: AnyColumnJson
    value: string
    onChange: (newValue: string) => void
    sx?: SxProps
}

function CellInput({column, value, onChange, sx}: CellInputProps) {
    const validateNumber = () => {
        let numberValue = parseFloat(value)
        if (isNaN(numberValue)) numberValue = 0
        onChange(numberValue.toString())
    }

    const validateUrl = () => {
        if (value.startsWith("https://", 0) || value.startsWith("http://", 0))
            return

        onChange(`https://${value}`)
    }

    const props: TextFieldProps = {
        variant: "outlined",
        label: column.name,
        value: value,
        onChange: (e) => onChange(e.target.value),
        sx: sx,
    }

    switch (column.type) {
        case ColumnType.NUMBER:
            return (
                <TextField {...props}
                           placeholder="Number"
                           inputProps={{inputMode: 'numeric', pattern: '[0-9]*'}}
                           onBlur={validateNumber}
                />
            )
        case ColumnType.URL:
            return (
                <TextField {...props}
                           placeholder="URL"
                           onBlur={validateUrl}
                />
            )
        case ColumnType.TEXT:
            return (
                <TextField {...props}
                           placeholder="Text"
                           multiline
                />
            )
        case ColumnType.PREDEFINED_OPTIONS:
            return (
                <PredefinedOptionSelect
                    label={column.name}
                    value={value}
                    choices={column.predefinedOptions ?? []}
                    onChange={(newValue) => onChange(newValue)}
                />
            )
    }
}

export default CellInput;